import { TFunction } from 'i18next';
import { interpolateFreeText } from '../../../../i18n';
import { Notification } from '../../../../models/Notification';

export const createNotificationMessage = (notification: Notification, t: TFunction) => {
  switch (notification.type) {
    case 'update':
      switch (notification.variant) {
        case 0:
          return t('notification:update_2_0_0_0');
        case 1:
          return t('notification:update_2_0_0_1');
        case 2:
          return t('notification:update_2_0_0_2');
        case 3:
        default:
          return t('notification:update_2_0_0_3');
      }
    case 'reaction-available':
      return t('notification:release_reaction');
    case 'resort-available':
      return t('notification:release_resort');
    case 'life-supports-available':
      return t('notification:release_life_support');
    case 'birthday-today':
      if (notification.target === 'myself') {
        return t('notification:birthday_today_myself');
      } else {
        return interpolateFreeText(t, 'notification:birthday_today', 'name', notification.name);
      }
    case 'birthday-today-leap':
      if (notification.target === 'myself') {
        return t('notification:birthday_today_leap_myself');
      } else {
        return interpolateFreeText(
          t,
          'notification:birthday_today_leap',
          'name',
          notification.name
        );
      }
    case 'birthday-tomorrow':
      if (notification.target === 'myself') {
        return t('notification:birthday_tomorrow_myself');
      } else {
        return interpolateFreeText(t, 'notification:birthday_tomorrow', 'name', notification.name);
      }
  }
};
